import Joi from 'joi-browser'

const statusConfiguration = Joi.object().keys({
  allowTransitionFrom: Joi.string().required(),
  allowTransitionTo: Joi.string().required(),
  label: Joi.string().required(),
  transitionLabel: Joi.string().required(),
  type: Joi.string().default('InProgress').valid('InProgress', 'Done', 'Initial'),
})

// These are the schemas of the return object from the api server
export const methodSchemas = {
  getAll: Joi.array().items(statusConfiguration),
}
export const collectionSchemas = {

}
export const entitySchema = statusConfiguration